export default __webpack_public_path__ + "static/media/Ismail.d08fb727.png";